import { events } from '@otto-ec/global-resources/event-q-bus';
import type { Topics } from '@shared/eventBus/eventQBus.types.ts';
import type { EventsOutgoing } from '@tilelist/application/ports/EventsOutgoing.ts';

type FirebaseEventParameter = {
    item_id: string;
};

type FireBaseLabels = {
    event_name: string;
    event_params: FirebaseEventParameter;
};

type FirebaseTrackingTopics = {
    'ft-apps.firebase.eventTracking': [FireBaseLabels];
};

/**
 *
 *
 */
export function createEventsOutgoing(): EventsOutgoing {
    const bus = events<Topics & FirebaseTrackingTopics>();

    return {
        publishTileListRendered(event) {
            bus.emit('ftfind.tilelist.loaded', event);
        },
        requestPageResolution(event) {
            bus.emit('ftfind.dresonRule.resolve', event);
        },
        pushHistoryCheckpoint(event) {
            bus.emit('ftfind.history.push', event);
        },
        seedHistoryState(event) {
            bus.emit('ftfind.history.merge', event);
        },
        notifyComparisonOpened() {
            bus.emit('reptile.comparison.opened');
        },
        notifyComparisonClosed() {
            bus.emit('reptile.comparison.closed');
        },
        trackProductView(itemId) {
            bus.emit('ft-apps.firebase.eventTracking', {
                event_name: 'view_item',
                event_params: { item_id: itemId },
            });
        },
    };
}
